// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

/**
 * Helper functions for strings
 */
export default class StringHelper {
  /**
   * Formats a string like C# string.format
   * String.format("{0} comes before {1}", "a", "b")
   * @param {string} stringToFormat - string to format
   * @param {object} tokens - list of tokens to feed the template
   * @returns {string} formatted string
   */
  static format(stringToFormat: string, ...tokens: string[]) {
    return stringToFormat.replace(/{(\d+)}/g, function (match, number) {
      return typeof tokens[number] != "undefined" ? tokens[number] : match;
    });
  }

  /**
   * Capitalize a string
   * @param {string} string - string to capitalize
   * @returns {string} capitalized string
   */
  static capitalize(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * Tests whether the text is html or not
   * @param {string} text - string to test
   * @returns {boolean}
   */
  static isFormattedHtml(text: string) {
    if (text == null) {
      return false;
    }

    return /<\/?[a-z][\s\S]*>/i.test(text);
  }

  /**
   * Gets company name from email address
   * @param {string} emailAddress - email address
   * @returns {string} company name
   */
  static getCompanyNameFromEmail(emailAddress: string) {
    const domain = emailAddress.substring(emailAddress.lastIndexOf("@") + 1);
    return domain.substring(0, domain.lastIndexOf("."));
  }
}
